'use client'
import { ConfirmationLayout } from '@/components/layout/payment-confirmation'
import Image from 'next/image'
import ButtonCustom from '@/components/button-custom'

export default function NotFound() {
  const handleNotFoundRouting = () => {
    window.location.href = 'https://www.formacion.ninja/planes'
  }
  return (
    <ConfirmationLayout>
      <div className="flex w-full justify-center">
        <div className="max-w-[1440px]">
          <div className="flex flex-row p-4 py-8">
            <div className="flex min-w-[300px] flex-col justify-center space-y-6 md:w-1/2">
              <p className="text-checkout-xxl font-normal">¡Lo sentimos!</p>
              <p className="text-4xl font-medium">Producto no encontrado</p>
              <Image
                className="block md:hidden"
                width={613}
                height={432}
                src={'/images/site-constructor.svg'}
                alt={''}
              />
              <p className="text-checkout-l font-normal">
                Pero no te preocupes, puedes dar un salto ninja a nuestros
                planes de suscripción y dominar nuevas habilidades en Formación
                Ninja. 🥷🚀
              </p>
              <ButtonCustom
                arrow={true}
                className="font-medium"
                onClick={handleNotFoundRouting}>
                Quiero saber más
              </ButtonCustom>
            </div>
            <div className="hidden flex-col items-center justify-center md:flex md:w-1/2">
              <Image
                width={613}
                height={432}
                src={'/images/site-constructor.svg'}
                alt={''}
              />
            </div>
          </div>
        </div>
      </div>
    </ConfirmationLayout>
  )
}
